var map = {
	"./JavaScript-Quiz.PNG": 24,
	"./Note-Taker.PNG": 25,
	"./Restaurant-Renaissance.PNG": 26,
	"./Tech-Blog.PNG": 27,
	"./excella.PNG": 28,
	"./hike_with_me.PNG": 29,
	"./run-buddy-img.PNG": 30,
	"./weather-app.PNG": 31,
	"./weather-dashboard.PNG": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;